import http from './http'
import {stringify} from 'qs'
import {HALL_URLTYPE, HALL_APPID, WECHAT_URL, WECHAT_SYS, service_url, extraWindows_url, accessToken} from './config'

//获取预约时间段列表
export const getAppointTimeList = (params) =>{
  // return new Promise(r => {
  //   setTimeout(() => {
  //     r(
  //       {"zip":0,"total":0,"route":"","data":{"state":1,"message":"获取数据成功","info":{"tDate":"2022-08-17","rDate":"2022-08-25","ruleList":[{"leftNum":10,"totalNum":10,"rDate":"2022-08-25","ruleId":"1004886722451865600","timeRange":"09:00-10:00"},{"leftNum":10,"totalNum":10,"rDate":"2022-08-25","ruleId":"1004886722451865601","timeRange":"10:00-11:00"},{"leftNum":10,"totalNum":10,"rDate":"2022-08-25","ruleId":"1004886722451865602","timeRange":"11:00-12:00"},{"leftNum":10,"totalNum":10,"rDate":"2022-08-25","ruleId":"1004886722451865603","timeRange":"13:30-14:30"},{"leftNum":10,"totalNum":10,"rDate":"2022-08-25","ruleId":"1004886722451865604","timeRange":"14:30-15:30"},
        
  //       // {"leftNum":10,"totalNum":10,"rDate":"2022-08-25","ruleId":"1004886722451865605","timeRange":"15:30-16:30"}
  //     ]}},"encrypt":0,"state":1,"message":""}
  //     )
  //   }, 1000)
  // })
  http.defaults.baseURL = service_url;
  params.appId = HALL_APPID;
  params.access_token = accessToken;
  return http.post('/fwapi/c/api.transfer/getPriorRuleInfo', stringify(params))
}
//提交预约信息
export const submitAppointment = (params) => {
  http.defaults.baseURL = service_url;
  params.appId = HALL_APPID;
  return http.post('/fwapi/c/api.transfer/submitRPriorBusi', stringify(params))
}

function genParmas () {
  var sig = "";
  var chars = "0123456789abcdef";
  var curTime = parseInt(Math.random() * (9999 - 1000 + 1) + 1000) + "" + Date.parse(new Date());
  sig = chars.charAt(parseInt(Math.random() * (15 - 15 + 1) + 10)) + chars.charAt(curTime.length) + "" + curTime;
 
  var key = "";
  var keyIndex = -1;
  for (var i = 0; i < 6; i++) {
      var c = sig.charAt(keyIndex + 1);
      key += c;
      keyIndex = chars.indexOf(c);
      if (keyIndex < 0 || keyIndex >= sig.length) {
          keyIndex = i;
      }
  }

  var timestamp = parseInt(Math.random() * (9999 - 1000 + 1) + 1000) + "_" + key + "_" + Date.parse(new Date());
  var t = timestamp;
  t = t.replace(/\+/g, "_");

  var tkey = "";
  var tkeyIndex = -1;
  for(var i=0;i<6;i++){
      var c=timestamp.charAt(tkeyIndex+1);
      tkey +=c;
      tkeyIndex = chars.indexOf(c);
      if(tkeyIndex<0 || tkeyIndex>=timestamp.length){
          tkeyIndex = i;
      }
  }

  var curUrl = '';
  curUrl += "?s=" + sig;
  curUrl += "&t=" + t;
  curUrl += "&o=" + tkey;
  return curUrl
}